export interface LanguageInfo {
  code: string;
  name: string;
}

export const DEFAULT_LANGUAGE = 'en';

export const LANGUAGES: LanguageInfo[] = [
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'es',
    name: 'Español',
  },
  {
    code: 'fr',
    name: 'Français',
  },
  {
    code: 'de',
    name: 'Deutsch',
  },
  {
    code: 'it',
    name: 'Italiano',
  },
  {
    code: 'pt',
    name: 'Português',
  },
  {
    code: 'nl',
    name: 'Nederlands',
  },
  {
    code: 'ru',
    name: 'Русский',
  },
  {
    code: 'ja',
    name: '日本語',
  },
  {
    code: 'zh-cn',
    name: '简体中文',
  },
];

export function getDefaultLanguage(): string {
  let browserLanguages: string[] = [];

  if (!!navigator.languages?.length) {
    browserLanguages = [...navigator.languages];
  } else if (navigator.language) {
    browserLanguages = [navigator.language];
    //  @ts-ignore
  } else if (navigator?.userLanguage) {
    //  @ts-ignore
    browserLanguages = [navigator?.userLanguage];
  }

  const supportedLanguages = new Set(LANGUAGES.map((language) => language.code));

  for (let language of browserLanguages) {
    language = `${language}`.trim().slice(0, 2).toLowerCase();

    if (supportedLanguages.has(language)) return language;
  }

  return DEFAULT_LANGUAGE;
}

